/* src/app/shared/shop/product-card/add-to-cart-steps/add-to-cart-steps.component.scss */
.navigation-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.navigation-button {
  --background: white;
  --border-radius: 5px;
  min-height: 32px;
  margin: 0;
  font-weight: 500;
}
.navigation-button::part(native) {
  padding: 5px;
}
.navigation-button:first-of-type {
  --background-hover: #0000000d;
  --background-activated: #0000000d;
  color: black;
  grid-column: 1;
}
.navigation-button:first-of-type ion-icon {
  margin-right: 5px;
}
.navigation-button:last-of-type {
  --background-hover: #eb445a1a;
  --background-activated: #eb445a1a;
  color: #eb445a;
  grid-column: 3;
}
.navigation-button:last-of-type ion-icon {
  font-size: 18px;
  margin-left: 5px;
}
.addToCartButton {
  --background: #000;
  --background-hover: rgb #252525 (37, 37, 37);
  --background-activated: rgb #383838 (56, 56, 56);
  --border-radius: 10px;
  min-height: 0;
  font-family: Barlow Semi Condensed;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
}
.addToCartButton::part(native) {
  padding: 14px 18px 14px 18px;
}
.addToCartButton ion-icon {
  font-size: 24px;
}
.addToCartButton span {
  font-family: League Spartan;
  font-size: 18px;
  font-weight: 600;
  line-height: 16.56px;
}
.addToCartButton .button-price {
  font-family: League Spartan;
  font-size: 18px;
  font-weight: 600;
  line-height: 16.56px;
  color: #43c0f6;
}
.product-options {
  gap: 15px;
  max-height: 80%;
}
.option-title {
  font-family: Barlow Semi Condensed;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
}
.increase-qty {
  gap: 15px;
}
.qty-text {
  font-size: clamp(1.125rem, 1.0714rem + 0.2597vw, 1.25rem);
}
.error-message {
  color: #eb445a;
}
.flex-container.no-wrapped {
  display: flex;
  justify-content: space-between;
}
.flex-container.wrapped {
  display: flex;
  justify-content: center;
}
.navigation-variants {
  max-height: calc(100% - 75px);
}
/*# sourceMappingURL=add-to-cart-steps.component-6GR725ND.css.map */
